import { render, staticRenderFns } from "./TransferredTo.container.vue?vue&type=template&id=616972e8&scoped=true&"
import script from "./TransferredTo.container.vue?vue&type=script&lang=js&"
export * from "./TransferredTo.container.vue?vue&type=script&lang=js&"
import style0 from "./TransferredTo.container.vue?vue&type=style&index=0&id=616972e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616972e8",
  null
  
)

export default component.exports